<template>
  <div class="status-change-procedure">
    <PlatDataGridSite grid-id="PeStudentChangeProcedure"></PlatDataGridSite>
  </div>
</template>

<script>
import PlatDataGridSite from '../../../wrapper/grid/PlatDataGridSite'
export default {
  name: 'StatusChangeProcedure',
  components: {
    PlatDataGridSite
  }
}
</script>

<style lang="scss">
  .status-change-procedure {
    height: 100%;
  }
</style>
